import { getCellStyle, GetHeaderStyle, PostJson } from "./Helper";
import { FieldDataType, FormControlType } from "./Helper2";

//**Convert class object to general object */
export const BuildsObject = (clazz) => {
  let newObject = {};
  for (const fd in clazz) {
    //** create new form item
    newObject = {
      ...newObject,
      [clazz[fd].fieldName]:
        clazz[fd].formControlType === FormControlType.DECIMAL ||
        clazz[fd].formControlType === FormControlType.NUMERIC
          ? 0
          : null,
    };
  }
  return newObject;
};

//** internal convert classs object to Form's Object */
const createFormItem = async (fieldObject) => {
  if (!fieldObject) return null;
  if (fieldObject.selectUrl != null) {
    fieldObject.selectData = await PostJson(
      fieldObject.selectUrl,
      fieldObject?.selectUrlParams
    );
  }
  return fieldObject;
};

// Create each control to show in a Form
export class FormObjectService {
  // แปลง class to each component renders in a From
  static async BuildsFormOBJs(clazz) {
    let oField = [];

    for (const fd in clazz) {
      //** create new form item
      let x = await createFormItem(clazz[fd]);
      if (x != null) {
        oField.push(x);
      }
    }

    return oField;
  }

  static ConvertToValuePair(obj) {
    let ret = {};
    for (const v in obj) {
      ret = { ...ret, ...{ [obj[v].oName]: obj[v].oValue } };
    }
    return ret;
  }

  static ConvertSwitchON2Boolean(obj) {
    for (const v in obj) {
      if (obj[v] === "on") obj[v] = true;
    }
  }

  /**
   * รวมข้อมูลจาก SelectBox เข้ากับ object ที่ต้องการ save
   * @param {*} objSave
   * @param {*} objFields
   * @returns
   */
  static IncludeSelectorKeyField(objSave, objFields) {
    let ret = objSave;
    for (let fi in objFields) {
      //** only ComboBox selector */
      if (objFields[fi].formControlType === FormControlType.SELECT) {
        //* filter only key field and its value to "Save Object" */
        let nn = objFields[fi].selectData.filter(
          (e) =>
            e[objFields[fi].selectValueName] == ret[objFields[fi].fieldName]
        );

        // สร้าง object ย่อย เมื่อต้อง
        if (!objFields[fi].selectValueOnly) {
          ret = { ...ret, ...{ [objFields[fi].fieldName]: nn[0] } };
        }
      }
    }
    return ret;
  }
}

export class FieldParams {
  dataType = FieldDataType.TEXT;
  formControlType = FormControlType.TEXT;
  value = null;
  caption = null;
  fieldName = null;
  isRequired = true;
  isListOnTable = true;
  isHiddenColumn = false;
  defaultTextAlign = "center";
  defaultCellStyle = getCellStyle();
  defaultHeaderStyle = GetHeaderStyle(
    this.defaultColumnWidth,
    this.defaultTextAlign
  );

  defaultColumnWidth = "100px";
  selectValueName = "id"; // key field
  selectDisplayName = "value";
  selectFirstRowText = "** ไม่ระบุ";
  selectHasFirstOption = true;
  selectData = [];
  selectUrl = null;
  selectValueOnly = false; //** use value from selector item */

  // searcher
  searchDisplayName = null;
  searchValueName = null;
  searchButtonClick = null;

  // table
  tableColumnFieldName = null;

  onChange = null;
  sort = true; // table sortting
  style = null; // object styles

  setColumnWidth(w) {
    this.defaultColumnWidth = w ?? "100px";
  }
  constructor(
    fieldName,
    caption,
    listOnTable,
    fieldDataType,
    formControlType,
    value
  ) {
    this.fieldDataType = fieldDataType ?? FieldDataType.TEXT;
    this.fieldName = fieldName;
    this.formControlType = formControlType ?? FormControlType.TEXT;
    this.isListOnTable = listOnTable ?? true;

    if (caption) this.caption = caption;
    if (value) {
      this.value = value;
    } else {
      if (fieldDataType === FieldDataType.NUMERIC) this.value = 0;
      if (fieldDataType === FieldDataType.BOOLEAN) this.value = false;
    }
  }
}
